"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { ensureCheckoutSessionReplay, initAmplitude } from "@/lib/analytics/amplitude";
import { getAnonymousId } from "@/lib/analytics/segment";
interface Props {
  apiKey: string | undefined;
}
export function AmplitudeProvider(t0) {
  const $ = _c(7);
  const {
    apiKey
  } = t0;
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== apiKey) {
    t1 = () => {
      if (apiKey) {
        initAmplitude(apiKey, getAnonymousId);
      }
    };
    t2 = [apiKey];
    $[0] = apiKey;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== apiKey || $[4] !== pathname) {
    t3 = () => {
      if (apiKey && pathname.startsWith("/store/checkout")) {
        ensureCheckoutSessionReplay();
      }
    };
    t4 = [apiKey, pathname];
    $[3] = apiKey;
    $[4] = pathname;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  return null;
}